   window.addEventListener('DOMContentLoaded', (event) => {
     var wrapper = document.querySelectorAll('#jdgm-widget-homepage')
     wrapper.forEach((item) => {
      if (item) {
       var clone = document.querySelector("#AllReviewsText").cloneNode(true);
      clone.style.display = "block"; // Make sure the cloned element is visible
      item.appendChild(clone);
    }
    });
    
         });